import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class SalesforceMapperService {
  mapPrograms(progs: any[]) {
    return progs.map((program) => ({
      id: program.Id,
      name: program.Name || program.name,
      orgId: program.Organization__c,
      comments: program.Gain_Description__c,
      teacher: program.Instructor__c,
      programDescription: program.Notes__c,
      location: program.Location__c,
      term: program.Payment_Term__c,
      disclaimer: program.Payment_Disclaimer__c,
      availableSpace: program.Available_Space__c,
      fee: program.Program_Fee__c,
      description: program.Program_Description__c,
      startDate: program.Start_Date__c,
      endDate: program.End_Date__c,
      startTime: program.Start_Time_Monday__c,
      endTime: program.End_Time_Monday__c,
      registrationUrl: program.Id,
      communityId: program.Program_Location__c,
      community: program.Program_Location__r?.Name || "Unknown",
      communityImage: this.normalizeSfResourceUrl(program.Community_Image__c),
      orgName: program.Organization_Name__c,
      orgAddress: program.Organization_Address__c,
      orgPhone: program.Organization_Number__c,
      ageGroup: program.Age_Group__c,
      category: program.Program_Catergory__c,
      progCategory: program.Category_of_Program__c,
      progCategoryName: program.Category_of_Program__r?.Category_Name__c,
      programImage: this.normalizeSfResourceUrl(program.Program_Image__c),
      programCurriculumOutline: program.Curriculum_Outline__c
        ? program.Curriculum_Outline__c.replace(/\r?\n/g, "<br>")
        : "",

      programKeyOutcome: program.Key_Outcome__c
        ? program.Key_Outcome__c.replace(/\r?\n/g, "<br>")
        : "",
    }));
  }
  mapOrganizations(orgs: any[]) {
    return orgs.map((organization) => ({
      id: organization.Id,
      name: organization.Name || organization.name,
      orgName: organization.Organization_Name__c,
      location: organization.Organization_Address__c,
      orgImage: this.normalizeSfResourceUrl(organization.Organization_Image__c),
      orgPhone: organization.Phone_Number__c,
      category: organization.Organization_Category__c,
      orgPolicy: organization.Organization_Policy__c,
      orgBanner: this.normalizeSfResourceUrl(
        organization.Organization_Banner__c
      ),
      collaboratorImage: this.normalizeSfResourceUrl(
        organization.Organization_Collaborator__c
      ),
      features: organization.Organization_Features__c
        ? organization.Organization_Features__c.split(/\r?\n/).filter(
            (f: string) => f.trim() !== ""
          )
        : [],
      purpose: organization.Organization_Purpose__c,
    }));
  }
  private normalizeSfResourceUrl(url: string): string | null {
    if (!url) return null;

    // 1) Strip all HTML tags
    url = url.replace(/<[^>]+>/g, "").trim();

    // 2) Decode only HTML entities, not URL encoding
    url = url.replace(/&amp;/g, "&").replace(/&quot;/g, '"');

    // ⚠️ remove decodeURIComponent, leave %20 and %26 intact

    // 3) Remove trailing "?" if present
    if (url.endsWith("?")) {
      url = url.slice(0, -1);
    }

    // 4) Return only valid http(s) links
    return url.startsWith("http") ? url : null;
  }

  mapCategories(cats: any[]) {
    return cats.map((category) => {
      const raw = category.Category_Image__c || "";
      const primary = this.normalizeSfResourceUrl(raw);

      return {
        id: category.Id,
        name: category.Name || category.name,
        categoryName: category.Category_Name__c,
        categoryImage: primary,
        categoryImages: primary ? [primary] : [],
        categoryDesc: category.Category_Description__c,
      };
    });
  }
}
